export function parseHtml(html) {
  return new DOMParser().parseFromString(html, 'text/html');
}

export function removedropContainerChilds(htmlString) {
  const doc = parseHtml(htmlString);
  const tds = doc.querySelectorAll('.drop-container-single, .drop-container-multiple');
  
  tds.forEach(td => {
    const imgs = td.querySelectorAll('img');
    imgs.forEach(img => img.style.opacity = 0);
  });
  
  return doc.body.innerHTML;
}

export function removeStyleFromCheckedNext(doc) {
  doc.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(input => {
    if (input.checked || input.hasAttribute('checked')) {
      let nextEl = input.nextElementSibling;
      while (nextEl) {
        if (nextEl.tagName?.toLowerCase() === 'span') {
          nextEl.removeAttribute('style');
        }
        nextEl.querySelectorAll?.('span').forEach(span => span.removeAttribute('style'));
        nextEl = nextEl.nextElementSibling;
      }
    }
  });
}

export function removeCheckedFromCheckboxes(htmlString) {
  const doc = parseHtml(htmlString);
  const checkboxes = doc.querySelectorAll('input[type="checkbox"]');

  checkboxes.forEach(checkbox => {
    checkbox.removeAttribute('checked');
    checkbox.checked = false;
  });

  return doc.body.innerHTML;
}

export function removeCheckedFromRadioButton(htmlString) {
  const doc = parseHtml(htmlString);
  const checkboxes = doc.querySelectorAll('input[type="radio"]');

  checkboxes.forEach(checkbox => {
    checkbox.removeAttribute('checked');
    checkbox.checked = false;
  });

  return doc.body.innerHTML;
}

export function replaceCheckedRadiosWithTick(htmlString) {
  const doc = parseHtml(htmlString);
  const radios = doc.querySelectorAll('input[type="radio"]');

  radios.forEach(radio => {
    if (radio.checked) {
      const tick = document.createElement('span');
      tick.textContent = '✔';
      tick.style.fontWeight = 'bold';
      tick.style.marginLeft = '4px';

      radio.replaceWith(tick);
    } else {
      radio.remove();
    }
  });

  return doc.body.innerHTML;
}

export const getMcCorrectAnswer = (mcAnswers) => {
  if (!mcAnswers) return '';

  const correctIndex = mcAnswers.findIndex(item => item.isCorrect);
  if (correctIndex === -1) return '';
  if (mcAnswers.length === 1) return ' => ' + mcAnswers[correctIndex].answer;

  return ' => ' + (correctIndex + 1);
};

export const fixSampleAnswerContent = (htmlString) => {
  const doc = parseHtml(htmlString);
  doc.querySelectorAll('ul').forEach(ul => {
    ul.classList.add('selectReplace');
  });

  return doc.body.innerHTML;
};